__webpack_require__.p = "https://cloudrx.xeotech.net/";